import { useEffect } from "react";

const Refetch = (props) => {
  const { isAuth, notAuth, refetch, cb } = props;

  useEffect(() => {
    if (isAuth && notAuth) {
      refetch();
      cb && cb();
    }
  }, [isAuth, notAuth, cb, refetch]);

  return null;
};

export default Refetch;
